import script from "./ApplicationComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationComponent.vue?vue&type=style&index=0&id=014eb89c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-014eb89c"]])

export default __exports__